import { useAppServices } from "../hooks/AppContext.tsx";
import { useImport } from "../hooks/bindings.ts";
import { Frame, PrimaryButton, Screen, TopBar } from "../components/Shell.tsx";
import { TypeTag } from "../components/TypeTag.tsx";
import styles from "../design-system/ui.module.css";

export function ImportScreen() {
  const { importer } = useAppServices();
  const state = useImport();

  return (
    <Frame>
      <Screen withNav={false}>
        <TopBar title="Import CSV" />
        <header className={styles.pageHead}>
          <h1>Import words</h1>
          <p>CSV is generated the same way as adding a word. Nothing is saved until you confirm.</p>
        </header>
        <label className={styles.field}>
          CSV file
          <input
            className={styles.input}
            type="file"
            accept=".csv,text/csv"
            onChange={async (event) => {
              const file = event.target.files?.[0];
              if (!file) {
                return;
              }
              importer.preview(file.name, await file.text());
            }}
          />
        </label>
        {state.headerErrors.map((error) => (
          <p className={styles.error} key={error}>
            {error}
          </p>
        ))}
        {state.truncated ? <p className={styles.error}>Only the first 200 data rows are kept.</p> : null}
        {state.error ? <p className={styles.error}>{state.error}</p> : null}
        {state.items.length ? (
          <div>
            {state.items.map((item) => (
              <article key={item.id} className={styles.detail}>
                <h2>
                  Row {item.row.rowNumber}: {item.row.word || "(empty)"}
                </h2>
                <p>
                  {item.status}
                  {item.reason ? ` · ${item.reason}` : ""}
                </p>
                {item.candidates.map((candidate) => (
                  <label key={candidate.id} className={styles.sense}>
                    <input
                      type="checkbox"
                      checked={item.selectedCandidateIds.includes(candidate.id)}
                      disabled={candidate.match.kind === "saved"}
                      onChange={() => importer.selectCandidate(item.id, candidate.id)}
                    />
                    <span>
                      <TypeTag type={candidate.type} /> {candidate.shortLabel}
                    </span>
                  </label>
                ))}
                {item.status === "ready" ? (
                  <label>
                    <input type="checkbox" checked={item.selectedForSave} onChange={() => importer.toggleSave(item.id)} />{" "}
                    Save this meaning
                  </label>
                ) : null}
              </article>
            ))}
          </div>
        ) : null}
        <div className={styles.stack}>
          {state.phase === "preview" ? (
            <PrimaryButton onClick={() => void importer.discoverAndGenerate()}>Find meanings</PrimaryButton>
          ) : null}
          {state.phase === "review" ? (
            <PrimaryButton onClick={() => void importer.generateSelected()}>Generate selected cards</PrimaryButton>
          ) : null}
          {state.items.some((item) => item.status === "ready") ? (
            <PrimaryButton onClick={() => void importer.saveReady()}>Save ready meanings</PrimaryButton>
          ) : null}
          <PrimaryButton secondary onClick={() => importer.cancel()}>
            Cancel import
          </PrimaryButton>
        </div>
        {state.report ? (
          <div className={`${styles.banner} ${styles.bannerSuccess}`}>
            Saved {state.report.saved}. Skipped {state.report.skipped}. Failed {state.report.failed}. Excluded{" "}
            {state.report.excluded}.
          </div>
        ) : null}
      </Screen>
    </Frame>
  );
}
